export default "__VITE_ASSET__DvAipqhI__"